import { useState } from 'react'
import { connect, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { selectActiveBuilding } from '@/reducers/buildingSelectorReducer'

import ModalContainer from '../../../../components/ModalContainer/ModelContainer'
import Icon from '../../../../components/Icons'
import NewTemplateWindow from '../../../../components/NewTemplateWindow/NewTemplateWindow'
import ChecklistsCreateCustomTaskModal from '../ChecklistsCreateCustomTaskModal/ChecklistsCreateCustomTaskModal'
import { selectUserData } from '../../../../reducers/userDataReducer'
import {
  setSelectedChecklistTemplate,
  selectChecklistsDefaultTemplates,
} from '../../../../reducers/Organisation/checklistsReducer'
import {
  getAmenities,
  selectAmenities,
} from '../../../../reducers/Organisation/reservationsReducer'

const ChecklistsCreateNewTaskModal = ({
  userData,
  defaultTemplates,
  onClose = () => {},
  setSelectedChecklistTemplate = () => {},
  getAmenities,
  amenities,
}) => {
  const { t } = useTranslation(['checklists-create-task', 'common'])
  const activeBuilding = useSelector(selectActiveBuilding)
  const [currentType, setCurrentType] = useState('')
  const [selectedView, setSelectedView] = useState('')

  const cardsOptions = [
    {
      name: 'inspections',
      icon: <Icon icon="moveInOut" viewBox="0 0 23 23" className={'icon-moveInOut'} />,
      title: t('checklists-create-task:newTaskModal.digitalInspections'),
    },
    {
      name: 'custom',
      icon: <Icon icon="checkClipboard" className={'icon-checkClipboard'} />,
      title: t('checklists-create-task:newTaskModal.customTask'),
    },
  ]

  const viewByType = {
    inspections: (
      <NewTemplateWindow
        handleCancel={onClose}
        setTemplate={setSelectedChecklistTemplate}
        templates={defaultTemplates}
        currentUserRole={userData.user.role}
      />
    ),
    custom: (
      <ChecklistsCreateCustomTaskModal
        onBack={() => setSelectedView('')}
        onClose={onClose}
        selectedBuilding={activeBuilding}
        getAmenities={getAmenities}
        amenities={amenities}
      />
    ),
  }

  return selectedView ? (
    viewByType[selectedView]
  ) : (
    <ModalContainer
      additionalClass={'checklist-modal'}
      onClose={onClose}
      headerTitle={t('checklists-create-task:newTaskModal.headerTitle')}
      headerIcon={<Icon icon="checkList" />}
    >
      <div className="checklist-modal-content checklist-create-new-task">
        <div className="checklist-card-items">
          <span className="checklist-card-items__title">
            {t('checklists-create-task:newTaskModal.selectTaskTypeDescription')}
          </span>
          <div className="checklist-card-items__wrapper">
            {cardsOptions.map((option) => (
              <div
                onClick={() => setCurrentType(option.name)}
                className={`checklist-card-item ${option.name === currentType ? 'selected' : ''}`}
                key={option.name}
              >
                {option.icon}
                <span>{option.title}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="checklist-modal-actions">
        <button className="button button-gray" onClick={onClose}>
          {t('common:actions.cancel')}
        </button>
        <button
          className="button button-primary auto-width"
          disabled={!currentType}
          onClick={() => setSelectedView(currentType)}
        >
          {t('checklists-create-task:shared.nextButton')}
        </button>
      </div>
    </ModalContainer>
  )
}

ChecklistsCreateNewTaskModal.propTypes = {
  onClose: PropTypes.func,
  setSelectedChecklistTemplate: PropTypes.func,
  userData: PropTypes.object,
  defaultTemplates: PropTypes.array,
  getAmenities: PropTypes.func,
  amenities: PropTypes.array,
}

export default connect(
  (state) => {
    const allTemplates = selectChecklistsDefaultTemplates(state)
    return {
      userData: selectUserData(state),
      defaultTemplates: allTemplates ? allTemplates.templates : [],
      amenities: selectAmenities(state),
    }
  },
  {
    setSelectedChecklistTemplate,
    getAmenities,
  },
)(ChecklistsCreateNewTaskModal)
